module.exports = __webpack_public_path__ + "img/pro-one.dfc8ba1a.png";